import Api from 'fou-api'
import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'
import Misc from 'src/utils/helper/misc'

export default {
  namespaced: true,

  state () {
    return {
      designers: [],
      minLength: 2,
      excludeChar: ',',
      tagValidation: false,
      sameTagName: [],
    }
  },

  getters: {
    list: state => {
      return state.designers
    },
    minLength: state => {
      return state.minLength
    },
    excludeChar: state => {
      return state.excludeChar
    },
    tagCheck: state => {
      return state.tagValidation
    },
    sameTagNameCheck: state => {
      return state.sameTagName
    }
  },

  mutations: {
    add (state, designers) {
      state.designers = [...designers]
    },
    clear (state) {
      state.designers = []
    },
    setTagValidation (state, value) {
      state.tagValidation = value
    },
    setSameTagName (state, value) {
      state.sameTagName = value
    }
  },

  actions: {
    getDesigner ({ commit, state }, options = {}) {
      return new Promise((resolve, reject) => {
        const isValid = Misc.validateScriptRegex(options.name)
        if (!isValid) {
          const err = Errors.create(Misc.scriptErrorObj())
          commit('errors/add', err)
          return reject(new Error('Cross scripting error'))
        }
        Api.Designers.getDesigners(options.name)
          .then((response) => {
            commit('add', (response?.data?.collection) || [])
            return resolve(response)
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('errors/add', err)
            return reject(err)
          })
      })
    },
    validateUniqueDesigners ({ commit, state }, options = {}) {
      return new Promise((resolve, reject) => {
        Api.Designers.checkUniqueDesigners(options)
          .then((response) => {
            resolve(response.data.designers)
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('errors/add', err)
            resolve(err)
          })
      })
    },
    clear ({ commit }) {
      commit('clear')
    }
  },

  modules: {
    errors: VuexErrors
  }
}
